import React from 'react'
import SupportForm from './SupportForm/SupportForm'
import Page from "../../Page/Page";
import SeoHelmet from '../../../Components/SeoHelmet/SeoHelmet';

const Support = () => {
    return (
        <Page>
            <SeoHelmet title="Support - Elite Partyz App" keywords="Party, Elite Party, Event, Event manager, Help, Support" description="HELP DESKSUPPORT CENTRE Complete the form and one of our support representatives will be in touch soon. " canonicalLink="/support" />
            <div className="support-page">
                <SupportForm />
            </div>
        </Page>
    )
}

export default Support
